module.exports = __webpack_public_path__ + "static/img/hall_4.983ce0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/hall_4.jpg
// module id = qzeS
// module chunks = 3